import { Component, OnInit } from '@angular/core';
import { AppSettingsService } from 'src/services/appsettings.service';
import { AppSettings } from '~/core/models/appsettings';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: true,
    imports: [DatePipe]
})
export class FooterComponent implements OnInit {
  public date: Date = new Date();
  public version: string = '0.0.0';

  constructor(private appSettingsService: AppSettingsService) {}

  // Initializes component and sets application version from settings
  public async ngOnInit(): Promise<void> {
    const settings: AppSettings = await this.appSettingsService.getSettings();
    this.version = settings.version;
  }
}
